import { useState } from "react";
import { Radio, InputNumber } from "antd";
import CustomInput from "../CustomInput";

function QRCodeGeneratorOptionComponent({
  isTableWiseQR,
  handleIsTableWiseQRChange,
  numberOfTable,
  handleNumberOfTableChange,
  handleQRCodeGenerate,
}) {
  return (
    <div className="p-4 flex items-center space-x-4 h-[64px]">
      <span className="">
        Do you want to generate QR code according to table?
      </span>
      <Radio.Group
        onChange={(e) => handleIsTableWiseQRChange(e.target.value === "yes")}
        value={isTableWiseQR ? "yes" : "no"}
        className="flex items-center space-x-2"
      >
        <Radio value="no">No</Radio>
        <Radio value="yes">Yes</Radio>
      </Radio.Group>

      {isTableWiseQR && (
        <InputNumber
          min={1}
          placeholder="Number of table"
          className="w-32"
          value={numberOfTable}
          onChange={handleNumberOfTableChange}
        />

        // <div className="w-[170px] mx-[230px] h-[42px]">
        //   <CustomInput
        //     value={numberOfTable}
        //     setValue={handleNumberOfTableChange}
        //     label={``}
        //     placeholder={`Number of table`}
        //     onlyNumeric={true}
        //     isStartingZeroAllowed={false}
        //     showPadding={false}
        //   />
        // </div>
      )}

      <button
        className="bg-green w-[100px] h-[40px] text-white font-ubold 
                  text-sm px-[12px] py-[8px] rounded"
        onClick={() => handleQRCodeGenerate()}
      >
        Generate
      </button>
    </div>
  );
}

export default QRCodeGeneratorOptionComponent;
